import { render, staticRenderFns } from "./Descricao-checkout.vue?vue&type=template&id=c8bdd2f2&scoped=true&"
import script from "./Descricao-checkout.vue?vue&type=script&lang=js&"
export * from "./Descricao-checkout.vue?vue&type=script&lang=js&"
import style0 from "./Descricao-checkout.vue?vue&type=style&index=0&id=c8bdd2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bdd2f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8bdd2f2')) {
      api.createRecord('c8bdd2f2', component.options)
    } else {
      api.reload('c8bdd2f2', component.options)
    }
    module.hot.accept("./Descricao-checkout.vue?vue&type=template&id=c8bdd2f2&scoped=true&", function () {
      api.rerender('c8bdd2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Checkout/components/steps/Descricao-checkout.vue"
export default component.exports